import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  appMenu: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  },
  logoBlock: {
    paddingLeft: theme.spacing(9),
    paddingBottom: theme.spacing(4),
    cursor: 'pointer'
  },
  menuBlock: {
    padding: theme.spacing(1, 4)
  },
  labSelector: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-around',
    padding: theme.spacing(1, 0)
  },
  navLink: {
    display: 'block',
    color: '#8688A1',
    margin: theme.spacing(1, 0),
    '&:first-child': {
      marginTop: 0
    },
    '&:last-child': {
      marginBottom: 0
    },
    textDecoration: 'none'
  },
  menuItemSelected: {
    color: '#000000',
    position: 'relative',
    '&:before': {
      position: 'absolute',
      content: '""',
      top: '10px',
      left: '-15px',
      height: '5px',
      width: '5px',
      borderRadius: '50%',
      backgroundColor: '#F7901E'
    }
  },
  subHeading: {
    color: '#000000'
  },
  divider: {
    border: '1px solid #E4E8F1'
  },
  logoutBlock: {
    padding: theme.spacing(1, 4),
    flexFlow: 'column nowrap',
    marginTop: 'auto'
  }
}))
